import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { CellLayout } from 'src/common/components/ConfigurableTable/Components/Cells/CellLayout';
import { TableTooltip } from 'src/common/components/Tooltip/TableTooltip';
import { TariffSummaryAlertConfiguration } from '../models/tariffSummaryModels';

type TariffSummaryAlertCellProps = {
  value: TariffSummaryAlertConfiguration;
};

export const TariffSummaryAlertCell = React.memo(({ value }: TariffSummaryAlertCellProps) => {
  const { t } = useTranslation();
  const { palette } = useTheme();

  const dataUsageDescription = value?.dataThreshold
    ? t('tariffSummary.table.usageAlert.dataThresholdPercentage', {
        dataThreshold: value.dataThreshold,
      })
    : '';
  const voiceUsageDescription = value?.voiceThreshold
    ? t('tariffSummary.table.usageAlert.voiceThresholdPercentage', {
        voiceThreshold: value.voiceThreshold,
      })
    : '';
  const smsUsageDescription = value?.smsThreshold
    ? t('tariffSummary.table.usageAlert.smsThresholdPercentage', {
        smsThreshold: value.smsThreshold,
      })
    : '';

  const description = [dataUsageDescription, voiceUsageDescription, smsUsageDescription].filter(
    Boolean,
  );

  return (
    <CellLayout data-testid="tariff-alert-cell">
      {description.length ? (
        <TableTooltip
          value={t('tariffSummary.table.usageAlert.alertTooltipHeader')}
          description={description}
        >
          <span aria-label="Alert set">
            <NotificationsNoneOutlinedIcon
              sx={{ fill: palette.blue[600] }}
              data-testid="tariff-alert-present"
            />
          </span>
        </TableTooltip>
      ) : (
        <span aria-label="No alert set">
          <NotificationsOffOutlinedIcon
            sx={{ fill: palette.border }}
            data-testid="no-tariff-alert"
          />
        </span>
      )}
    </CellLayout>
  );
});
